module.exports=/[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/


/*****************
 ** WEBPACK FOOTER
 ** ../~/markdown-it/~/uc.micro/categories/Cf/regex.js
 ** module id = 586
 ** module chunks = 1
 **/